module.exports = __webpack_public_path__ + "static/media/转接模块B1.321f7c34.png";